export const DYNAMIC_INCENTIVES_API = {
  CHALLENGES: "/engagement/dynamic-incentives/challenges",
  CHALLENGES_HISTORY: "/engagement/dynamic-incentives/challenges/history",
  INCENTIVE_PROGRAM: "/engagement/incentive-program",
  ACCEPT_DYNAMIC_INCENTIVE_PROGRAM: (
    merchantChallengeBusinessId: string,
  ): string =>
    `/engagement/dynamic-incentives/challenges/${merchantChallengeBusinessId}/accept`,
  DECLINE_DYNAMIC_INCENTIVE_PROGRAM: (
    merchantChallengeBusinessId: string,
  ): string =>
    `/engagement/dynamic-incentives/challenges/${merchantChallengeBusinessId}/decline`,
  FEEDBACK_DYNAMIC_INCENTIVE_PROGRAM: (
    merchantChallengeBusinessId: string,
  ): string =>
    `/engagement/dynamic-incentives/challenges/${merchantChallengeBusinessId}/feedback`,
};
